import React, { useContext } from 'react'
import styled from 'styled-components'
import { ThemeContext } from '../providers/ThemeProvider'
import { useStateValue } from '../providers/StateProvider'

const File = styled.div`
  width: 80%;
  max-width: 900px;
  background-color: #E8C38F;
  padding: 2em;
  position: relative;
  margin: 4em 0;
  font-size: 1em;
  line-height: 1.4;
  color: #333;

  h1 {
    font-size: 1.5em;
  }

  span, h1 span {
    text-transform: uppercase;
    font-size: 0.875em;
    color: #555;
    letter-spacing: 3px;
  }

  ul {
    list-style-type: none;
    padding-left: 0;
    margin-bottom: 50px;
  }

  p, ul {
    margin-top: 8px;
  }

  p, li {
    font-family: 'PT Mono';
  }

  @media (min-width: 650px) {
    ul {
      display: flex;
      flex-wrap: wrap;
    }

    li {
      width: 50%;
    }
  }
`

const Descr = styled.div`
  margin: 32px 0;
`

const Headshot = styled.div`
  height: 200px;
  width: 200px;
  border: 5px solid #fff;
  border-radius: 16px;
  float: right;
  background: url(${props => props.image}), #533a16;
  background-blend-mode: lighten;
  transform: rotate(2deg);
  box-shadow: 1px 3px 5px rgba(21,21,24,.3);
  margin: 0 0 32px 32px;
`

const PaperClip = styled.div`
  border: 3px solid #747584;
  border-radius: 8px;
  height: 80px;
  width: 20px;
  position: absolute;
  top: -10px;
  right: 60px;
  z-index: 1;
  transform: rotate(5deg);
  box-shadow: 1px 1px 4px rgba(21,21,24,.2);
`

const Fold = styled.div`
  border-right: 100px solid #DAAD76;
  border-bottom: 60px solid #151518;
  position: absolute;
  bottom: 0;
  left: 0;
  box-shadow: 1px 0 3px rgba(21,21,24,.3);
`

const Assemble = styled.button`
  color: #D10A0A;
  font-family: 'PT Mono';
  font-size: 1.125em;
  background: transparent;
  border: 2px dashed #D10A0A;
  padding: 8px;
  position: absolute;
  bottom: 32px;
  right: 32px;
  transform: rotate(-3deg);
  cursor: pointer;
`

const EvilFold = styled.div`
  border-right: 100px solid #DAAD76;
  border-bottom: 60px solid #360C10;
  position: absolute;
  bottom: 0;
  left: 0;
  box-shadow: 1px 0 3px rgba(21,21,24,.3);
`

const Results = (props) => {

  const { mode } = useContext(ThemeContext)
  const { team, addToTeam, removeFromTeam } = useStateValue()

  const isEvil = mode === 'hydra'
  const isAssembled = Boolean(team.find(c => c.id === props.id))

  const handleClick = () => {
    if (!isAssembled) {
      addToTeam({
        id: props.id,
        name: props.name,
        image: props.image
      })
    } else {
      removeFromTeam([props.id])
    }
  }

  return (
    <File>
      <PaperClip></PaperClip>
      <Headshot image={ props.image }></Headshot>
      <h1><span>subject name </span>{ props.name }</h1>
      <Descr>
        <span>background</span>
        <p>{ props.description }</p>
      </Descr>
      <div>
        <span>documented missions</span>
        <ul>
          { props.cv.map((item, index) => (
              <li key={ index }>{ item }</li>
          ))}
        </ul>
      </div>
      {(props.name !== 'Retrieving Records...')
        ? <Assemble onClick={handleClick}>
            {isAssembled ? 'Remove from Team' : 'Add to Team'}
          </Assemble>
        : null }
      {isEvil ? ( <EvilFold></EvilFold> ) : ( <Fold></Fold> ) }
    </File>
)}

export default Results
